import { CategoryId } from 'core/type/Category.types';

export interface SubcategoryKeyType {
    queryKey: string;
    apiId: SubcategoryId;
}

export enum SubcategoryId {
    BeerAndWineTasting = 'BeerAndWineTasting',
    Buffet = 'Buffet',
    CookingClasses = 'CookingClasses',
    LunchAndDinnerCruises = 'LunchAndDinnerCruises',
    Restaurants = 'Restaurants',
    OtherFoodAndDrinks = 'OtherFoodAndDrinks',
    FamilyFriendlyDinner = 'FamilyFriendlyDinner',
    LocalDiningExperiences = 'LocalDiningExperiences',
    RomanticDinner = 'RomanticDinner',
    AmusementParks = 'AmusementParks',
    AquariumsAndZoos = 'AquariumsAndZoos',
    CityPasses = 'CityPasses',
    EventsAndExhibitions = 'EventsAndExhibitions',
    SkipTheQueue = 'SkipTheQueue',
    MuseumsAndGalleries = 'MuseumsAndGalleries',
    ObservationDecks = 'ObservationDecks',
    ShowsAndPerformances = 'ShowsAndPerformances',
    OtherAttractions = 'OtherAttractions',
    AdultsOnlyAttractions = 'AdultsOnlyAttractions',
    AdventureAttractions = 'AdventureAttractions',
    ArtAndCulturalAttractions = 'ArtAndCulturalAttractions',
    FamilyFriendlyAttractions = 'FamilyFriendlyAttractions',
    HistoricalAttractions = 'HistoricalAttractions',
    IndoorAttractions = 'IndoorAttractions',
    NatureAttractions = 'NatureAttractions',
    NightTimeAttractions = 'NightTimeAttractions',
    OutdoorAttractions = 'OutdoorAttractions',
    RomanticAttractions = 'RomanticAttractions',
    AirportTransfer = 'AirportTransfer',
    Buses = 'Buses',
    HopOnHopOffTransportation = 'HopOnHopOffTransportation',
    CableCars = 'CableCars',
    VehicleRentals = 'VehicleRentals',
    BicycleAndEScooterRentals = 'BicycleAndEScooterRentals',
    WaterTransportation = 'WaterTransportation',
    PrivateDrivers = 'PrivateDrivers',
    Trains = 'Trains',
    OtherTransportation = 'OtherTransportation',
    AirportFastTrack = 'AirportFastTrack',
    AirportLounges = 'AirportLounges',
    LuggageServices = 'LuggageServices',
    OtherTravelEssentials = 'OtherTravelEssentials',
    BicycleTours = 'BicycleTours',
    BoatAndYachtTours = 'BoatAndYachtTours',
    BusTours = 'BusTours',
    HopOnHopOffTours = 'HopOnHopOffTours',
    MotorbikeTours = 'MotorbikeTours',
    PrivateCarTours = 'PrivateCarTours',
    SelfGuidedTours = 'SelfGuidedTours',
    ShoppingTours = 'ShoppingTours',
    WalkingTours = 'WalkingTours',
    FullDayTours = 'FullDayTours',
    HalfDayTours = 'HalfDayTours',
    MultiDayTours = 'MultiDayTours',
    PrivateTours = 'PrivateTours',
    SmallGroupTours = 'SmallGroupTours',
    OtherTours = 'OtherTours',
    CulinaryTours = 'CulinaryTours',
    AdultsOnlyTours = 'AdultsOnlyTours',
    AdventureTours = 'AdventureTours',
    ArtAndCulturalTours = 'ArtAndCulturalTours',
    FamilyFriendlyTours = 'FamilyFriendlyTours',
    HistoricalTours = 'HistoricalTours',
    IndoorTours = 'IndoorTours',
    LocalTours = 'LocalTours',
    LuxuryTours = 'LuxuryTours',
    NatureTours = 'NatureTours',
    NightTours = 'NightTours',
    OutdoorTours = 'OutdoorTours',
    RomanticTours = 'RomanticTours',
    SeasonalTours = 'SeasonalTours',
    SimCards = 'SimCards',
    Wifi = 'Wifi',
    OtherSimAndWifi = 'OtherSimAndWifi',
    BeautyAndSkincare = 'BeautyAndSkincare',
    ClothingAndCostumeRental = 'ClothingAndCostumeRental',
    PhotographyExperience = 'PhotographyExperience',
    SpasAndHotSprings = 'SpasAndHotSprings',
    WorkshopsAndClasses = 'WorkshopsAndClasses',
    OtherExperiences = 'OtherExperiences',
    AdultsOnlyExperiences = 'AdultsOnlyExperiences',
    AdventureExperiences = 'AdventureExperiences',
    ArtAndCulturalExperiences = 'ArtAndCulturalExperiences',
    FamilyFriendlyExperiences = 'FamilyFriendlyExperiences',
    HistoricalExperiences = 'HistoricalExperiences',
    IndoorExperiences = 'IndoorExperiences',
    LocalExperiences = 'LocalExperiences',
    LuxuryExperiences = 'LuxuryExperiences',
    NatureExperiences = 'NatureExperiences',
    NightlifeExperiences = 'NightlifeExperiences',
    OutdoorExperiences = 'OutdoorExperiences',
    RomanticExperiences = 'RomanticExperiences',
    SeasonalExperiences = 'SeasonalExperiences',
}

export const CategoryKeyRecord: Record<SubcategoryId, SubcategoryKeyType> = {
    [SubcategoryId.BeerAndWineTasting]: { queryKey: '1', apiId: SubcategoryId.BeerAndWineTasting },
    [SubcategoryId.Buffet]: { queryKey: '2', apiId: SubcategoryId.Buffet },
    [SubcategoryId.CookingClasses]: { queryKey: '3', apiId: SubcategoryId.CookingClasses },
    [SubcategoryId.LunchAndDinnerCruises]: { queryKey: '4', apiId: SubcategoryId.LunchAndDinnerCruises },
    [SubcategoryId.Restaurants]: { queryKey: '5', apiId: SubcategoryId.Restaurants },
    [SubcategoryId.OtherFoodAndDrinks]: { queryKey: '6', apiId: SubcategoryId.OtherFoodAndDrinks },
    [SubcategoryId.FamilyFriendlyDinner]: { queryKey: '7', apiId: SubcategoryId.FamilyFriendlyDinner },
    [SubcategoryId.LocalDiningExperiences]: { queryKey: '8', apiId: SubcategoryId.LocalDiningExperiences },
    [SubcategoryId.RomanticDinner]: { queryKey: '9', apiId: SubcategoryId.RomanticDinner },
    [SubcategoryId.AmusementParks]: { queryKey: '10', apiId: SubcategoryId.AmusementParks },
    [SubcategoryId.AquariumsAndZoos]: { queryKey: '11', apiId: SubcategoryId.AquariumsAndZoos },
    [SubcategoryId.CityPasses]: { queryKey: '12', apiId: SubcategoryId.CityPasses },
    [SubcategoryId.EventsAndExhibitions]: { queryKey: '13', apiId: SubcategoryId.EventsAndExhibitions },
    [SubcategoryId.SkipTheQueue]: { queryKey: '14', apiId: SubcategoryId.SkipTheQueue },
    [SubcategoryId.MuseumsAndGalleries]: { queryKey: '15', apiId: SubcategoryId.MuseumsAndGalleries },
    [SubcategoryId.ObservationDecks]: { queryKey: '16', apiId: SubcategoryId.ObservationDecks },
    [SubcategoryId.ShowsAndPerformances]: { queryKey: '17', apiId: SubcategoryId.ShowsAndPerformances },
    [SubcategoryId.OtherAttractions]: { queryKey: '18', apiId: SubcategoryId.OtherAttractions },
    [SubcategoryId.AdultsOnlyAttractions]: { queryKey: '19', apiId: SubcategoryId.AdultsOnlyAttractions },
    [SubcategoryId.AdventureAttractions]: { queryKey: '20', apiId: SubcategoryId.AdventureAttractions },
    [SubcategoryId.ArtAndCulturalAttractions]: { queryKey: '21', apiId: SubcategoryId.ArtAndCulturalAttractions },
    [SubcategoryId.FamilyFriendlyAttractions]: { queryKey: '22', apiId: SubcategoryId.FamilyFriendlyAttractions },
    [SubcategoryId.HistoricalAttractions]: { queryKey: '23', apiId: SubcategoryId.HistoricalAttractions },
    [SubcategoryId.IndoorAttractions]: { queryKey: '24', apiId: SubcategoryId.IndoorAttractions },
    [SubcategoryId.NatureAttractions]: { queryKey: '25', apiId: SubcategoryId.NatureAttractions },
    [SubcategoryId.NightTimeAttractions]: { queryKey: '26', apiId: SubcategoryId.NightTimeAttractions },
    [SubcategoryId.OutdoorAttractions]: { queryKey: '27', apiId: SubcategoryId.OutdoorAttractions },
    [SubcategoryId.RomanticAttractions]: { queryKey: '28', apiId: SubcategoryId.RomanticAttractions },
    [SubcategoryId.AirportTransfer]: { queryKey: '29', apiId: SubcategoryId.AirportTransfer },
    [SubcategoryId.Buses]: { queryKey: '30', apiId: SubcategoryId.Buses },
    [SubcategoryId.HopOnHopOffTransportation]: { queryKey: '31', apiId: SubcategoryId.HopOnHopOffTransportation },
    [SubcategoryId.CableCars]: { queryKey: '32', apiId: SubcategoryId.CableCars },
    [SubcategoryId.VehicleRentals]: { queryKey: '33', apiId: SubcategoryId.VehicleRentals },
    [SubcategoryId.BicycleAndEScooterRentals]: { queryKey: '34', apiId: SubcategoryId.BicycleAndEScooterRentals },
    [SubcategoryId.WaterTransportation]: { queryKey: '35', apiId: SubcategoryId.WaterTransportation },
    [SubcategoryId.PrivateDrivers]: { queryKey: '36', apiId: SubcategoryId.PrivateDrivers },
    [SubcategoryId.Trains]: { queryKey: '37', apiId: SubcategoryId.Trains },
    [SubcategoryId.OtherTransportation]: { queryKey: '38', apiId: SubcategoryId.OtherTransportation },
    [SubcategoryId.AirportFastTrack]: { queryKey: '39', apiId: SubcategoryId.AirportFastTrack },
    [SubcategoryId.AirportLounges]: { queryKey: '40', apiId: SubcategoryId.AirportLounges },
    [SubcategoryId.LuggageServices]: { queryKey: '41', apiId: SubcategoryId.LuggageServices },
    [SubcategoryId.OtherTravelEssentials]: { queryKey: '42', apiId: SubcategoryId.OtherTravelEssentials },
    [SubcategoryId.BicycleTours]: { queryKey: '43', apiId: SubcategoryId.BicycleTours },
    [SubcategoryId.BoatAndYachtTours]: { queryKey: '44', apiId: SubcategoryId.BoatAndYachtTours },
    [SubcategoryId.BusTours]: { queryKey: '45', apiId: SubcategoryId.BusTours },
    [SubcategoryId.HopOnHopOffTours]: { queryKey: '46', apiId: SubcategoryId.HopOnHopOffTours },
    [SubcategoryId.MotorbikeTours]: { queryKey: '47', apiId: SubcategoryId.MotorbikeTours },
    [SubcategoryId.PrivateCarTours]: { queryKey: '48', apiId: SubcategoryId.PrivateCarTours },
    [SubcategoryId.SelfGuidedTours]: { queryKey: '49', apiId: SubcategoryId.SelfGuidedTours },
    [SubcategoryId.ShoppingTours]: { queryKey: '50', apiId: SubcategoryId.ShoppingTours },
    [SubcategoryId.WalkingTours]: { queryKey: '51', apiId: SubcategoryId.WalkingTours },
    [SubcategoryId.FullDayTours]: { queryKey: '52', apiId: SubcategoryId.FullDayTours },
    [SubcategoryId.HalfDayTours]: { queryKey: '53', apiId: SubcategoryId.HalfDayTours },
    [SubcategoryId.MultiDayTours]: { queryKey: '54', apiId: SubcategoryId.MultiDayTours },
    [SubcategoryId.PrivateTours]: { queryKey: '55', apiId: SubcategoryId.PrivateTours },
    [SubcategoryId.SmallGroupTours]: { queryKey: '56', apiId: SubcategoryId.SmallGroupTours },
    [SubcategoryId.OtherTours]: { queryKey: '57', apiId: SubcategoryId.OtherTours },
    [SubcategoryId.CulinaryTours]: { queryKey: '58', apiId: SubcategoryId.CulinaryTours },
    [SubcategoryId.AdultsOnlyTours]: { queryKey: '59', apiId: SubcategoryId.AdultsOnlyTours },
    [SubcategoryId.AdventureTours]: { queryKey: '60', apiId: SubcategoryId.AdventureTours },
    [SubcategoryId.ArtAndCulturalTours]: { queryKey: '61', apiId: SubcategoryId.ArtAndCulturalTours },
    [SubcategoryId.FamilyFriendlyTours]: { queryKey: '62', apiId: SubcategoryId.FamilyFriendlyTours },
    [SubcategoryId.HistoricalTours]: { queryKey: '63', apiId: SubcategoryId.HistoricalTours },
    [SubcategoryId.IndoorTours]: { queryKey: '64', apiId: SubcategoryId.IndoorTours },
    [SubcategoryId.LocalTours]: { queryKey: '65', apiId: SubcategoryId.LocalTours },
    [SubcategoryId.LuxuryTours]: { queryKey: '66', apiId: SubcategoryId.LuxuryTours },
    [SubcategoryId.NatureTours]: { queryKey: '67', apiId: SubcategoryId.NatureTours },
    [SubcategoryId.NightTours]: { queryKey: '68', apiId: SubcategoryId.NightTours },
    [SubcategoryId.OutdoorTours]: { queryKey: '69', apiId: SubcategoryId.OutdoorTours },
    [SubcategoryId.RomanticTours]: { queryKey: '70', apiId: SubcategoryId.RomanticTours },
    [SubcategoryId.SeasonalTours]: { queryKey: '71', apiId: SubcategoryId.SeasonalTours },
    [SubcategoryId.SimCards]: { queryKey: '72', apiId: SubcategoryId.SimCards },
    [SubcategoryId.Wifi]: { queryKey: '73', apiId: SubcategoryId.Wifi },
    [SubcategoryId.OtherSimAndWifi]: { queryKey: '74', apiId: SubcategoryId.OtherSimAndWifi },
    [SubcategoryId.BeautyAndSkincare]: { queryKey: '75', apiId: SubcategoryId.BeautyAndSkincare },
    [SubcategoryId.ClothingAndCostumeRental]: { queryKey: '76', apiId: SubcategoryId.ClothingAndCostumeRental },
    [SubcategoryId.PhotographyExperience]: { queryKey: '77', apiId: SubcategoryId.PhotographyExperience },
    [SubcategoryId.SpasAndHotSprings]: { queryKey: '78', apiId: SubcategoryId.SpasAndHotSprings },
    [SubcategoryId.WorkshopsAndClasses]: { queryKey: '79', apiId: SubcategoryId.WorkshopsAndClasses },
    [SubcategoryId.OtherExperiences]: { queryKey: '80', apiId: SubcategoryId.OtherExperiences },
    [SubcategoryId.AdultsOnlyExperiences]: { queryKey: '81', apiId: SubcategoryId.AdultsOnlyExperiences },
    [SubcategoryId.AdventureExperiences]: { queryKey: '82', apiId: SubcategoryId.AdventureExperiences },
    [SubcategoryId.ArtAndCulturalExperiences]: { queryKey: '83', apiId: SubcategoryId.ArtAndCulturalExperiences },
    [SubcategoryId.FamilyFriendlyExperiences]: { queryKey: '84', apiId: SubcategoryId.FamilyFriendlyExperiences },
    [SubcategoryId.HistoricalExperiences]: { queryKey: '85', apiId: SubcategoryId.HistoricalExperiences },
    [SubcategoryId.IndoorExperiences]: { queryKey: '86', apiId: SubcategoryId.IndoorExperiences },
    [SubcategoryId.LocalExperiences]: { queryKey: '87', apiId: SubcategoryId.LocalExperiences },
    [SubcategoryId.LuxuryExperiences]: { queryKey: '88', apiId: SubcategoryId.LuxuryExperiences },
    [SubcategoryId.NatureExperiences]: { queryKey: '89', apiId: SubcategoryId.NatureExperiences },
    [SubcategoryId.NightlifeExperiences]: { queryKey: '90', apiId: SubcategoryId.NightlifeExperiences },
    [SubcategoryId.OutdoorExperiences]: { queryKey: '91', apiId: SubcategoryId.OutdoorExperiences },
    [SubcategoryId.RomanticExperiences]: { queryKey: '92', apiId: SubcategoryId.RomanticExperiences },
    [SubcategoryId.SeasonalExperiences]: { queryKey: '93', apiId: SubcategoryId.SeasonalExperiences },
};

export const SubcategoryKey: SubcategoryKeyType[] = Object.values(CategoryKeyRecord);

export const SubcategoryCms: Record<SubcategoryId, number> = {
    [SubcategoryId.BeerAndWineTasting]: 349287,
    [SubcategoryId.Buffet]: 349288,
    [SubcategoryId.CookingClasses]: 349289,
    [SubcategoryId.LunchAndDinnerCruises]: 349290,
    [SubcategoryId.Restaurants]: 349291,
    [SubcategoryId.OtherFoodAndDrinks]: 349292,
    [SubcategoryId.FamilyFriendlyDinner]: 349293,
    [SubcategoryId.LocalDiningExperiences]: 349294,
    [SubcategoryId.RomanticDinner]: 349295,
    [SubcategoryId.AmusementParks]: 349296,
    [SubcategoryId.AquariumsAndZoos]: 349297,
    [SubcategoryId.CityPasses]: 349298,
    [SubcategoryId.EventsAndExhibitions]: 349299,
    [SubcategoryId.SkipTheQueue]: 349300,
    [SubcategoryId.MuseumsAndGalleries]: 349301,
    [SubcategoryId.ObservationDecks]: 349302,
    [SubcategoryId.ShowsAndPerformances]: 349303,
    [SubcategoryId.OtherAttractions]: 349304,
    [SubcategoryId.AdultsOnlyAttractions]: 349305,
    [SubcategoryId.AdventureAttractions]: 349306,
    [SubcategoryId.ArtAndCulturalAttractions]: 349307,
    [SubcategoryId.FamilyFriendlyAttractions]: 349308,
    [SubcategoryId.HistoricalAttractions]: 349309,
    [SubcategoryId.IndoorAttractions]: 349310,
    [SubcategoryId.NatureAttractions]: 349311,
    [SubcategoryId.NightTimeAttractions]: 349312,
    [SubcategoryId.OutdoorAttractions]: 349313,
    [SubcategoryId.RomanticAttractions]: 349314,
    [SubcategoryId.AirportTransfer]: 349315,
    [SubcategoryId.Buses]: 349316,
    [SubcategoryId.HopOnHopOffTransportation]: 349317,
    [SubcategoryId.CableCars]: 349318,
    [SubcategoryId.VehicleRentals]: 349319,
    [SubcategoryId.BicycleAndEScooterRentals]: 349320,
    [SubcategoryId.WaterTransportation]: 349321,
    [SubcategoryId.PrivateDrivers]: 349322,
    [SubcategoryId.Trains]: 349323,
    [SubcategoryId.OtherTransportation]: 349324,
    [SubcategoryId.AirportFastTrack]: 349325,
    [SubcategoryId.AirportLounges]: 349326,
    [SubcategoryId.LuggageServices]: 349327,
    [SubcategoryId.OtherTravelEssentials]: 349328,
    [SubcategoryId.BicycleTours]: 349329,
    [SubcategoryId.BoatAndYachtTours]: 349330,
    [SubcategoryId.BusTours]: 349331,
    [SubcategoryId.HopOnHopOffTours]: 349332,
    [SubcategoryId.MotorbikeTours]: 349333,
    [SubcategoryId.PrivateCarTours]: 349334,
    [SubcategoryId.SelfGuidedTours]: 349335,
    [SubcategoryId.ShoppingTours]: 349336,
    [SubcategoryId.WalkingTours]: 349337,
    [SubcategoryId.FullDayTours]: 349338,
    [SubcategoryId.HalfDayTours]: 349339,
    [SubcategoryId.MultiDayTours]: 349340,
    [SubcategoryId.PrivateTours]: 349341,
    [SubcategoryId.SmallGroupTours]: 349342,
    [SubcategoryId.OtherTours]: 349343,
    [SubcategoryId.CulinaryTours]: 349344,
    [SubcategoryId.AdultsOnlyTours]: 349345,
    [SubcategoryId.AdventureTours]: 349346,
    [SubcategoryId.ArtAndCulturalTours]: 349347,
    [SubcategoryId.FamilyFriendlyTours]: 349348,
    [SubcategoryId.HistoricalTours]: 349349,
    [SubcategoryId.IndoorTours]: 349350,
    [SubcategoryId.LocalTours]: 349351,
    [SubcategoryId.LuxuryTours]: 349352,
    [SubcategoryId.NatureTours]: 349353,
    [SubcategoryId.NightTours]: 349354,
    [SubcategoryId.OutdoorTours]: 349355,
    [SubcategoryId.RomanticTours]: 349356,
    [SubcategoryId.SeasonalTours]: 349357,
    [SubcategoryId.SimCards]: 349358,
    [SubcategoryId.Wifi]: 349359,
    [SubcategoryId.OtherSimAndWifi]: 349360,
    [SubcategoryId.BeautyAndSkincare]: 349361,
    [SubcategoryId.ClothingAndCostumeRental]: 349362,
    [SubcategoryId.PhotographyExperience]: 349363,
    [SubcategoryId.SpasAndHotSprings]: 349364,
    [SubcategoryId.WorkshopsAndClasses]: 349365,
    [SubcategoryId.OtherExperiences]: 349366,
    [SubcategoryId.AdultsOnlyExperiences]: 349367,
    [SubcategoryId.AdventureExperiences]: 349368,
    [SubcategoryId.ArtAndCulturalExperiences]: 349369,
    [SubcategoryId.FamilyFriendlyExperiences]: 349370,
    [SubcategoryId.HistoricalExperiences]: 349371,
    [SubcategoryId.IndoorExperiences]: 349372,
    [SubcategoryId.LocalExperiences]: 349373,
    [SubcategoryId.LuxuryExperiences]: 349374,
    [SubcategoryId.NatureExperiences]: 349375,
    [SubcategoryId.NightlifeExperiences]: 349376,
    [SubcategoryId.OutdoorExperiences]: 349377,
    [SubcategoryId.RomanticExperiences]: 349378,
    [SubcategoryId.SeasonalExperiences]: 349379,
};

export const SubcategoryParentId: Record<SubcategoryId, CategoryId> = {
    [SubcategoryId.BeerAndWineTasting]: CategoryId.FoodAndDrinks,
    [SubcategoryId.Buffet]: CategoryId.FoodAndDrinks,
    [SubcategoryId.CookingClasses]: CategoryId.FoodAndDrinks,
    [SubcategoryId.LunchAndDinnerCruises]: CategoryId.FoodAndDrinks,
    [SubcategoryId.Restaurants]: CategoryId.FoodAndDrinks,
    [SubcategoryId.OtherFoodAndDrinks]: CategoryId.FoodAndDrinks,
    [SubcategoryId.FamilyFriendlyDinner]: CategoryId.FoodAndDrinks,
    [SubcategoryId.LocalDiningExperiences]: CategoryId.FoodAndDrinks,
    [SubcategoryId.RomanticDinner]: CategoryId.FoodAndDrinks,
    [SubcategoryId.AmusementParks]: CategoryId.Attractions,
    [SubcategoryId.AquariumsAndZoos]: CategoryId.Attractions,
    [SubcategoryId.CityPasses]: CategoryId.Attractions,
    [SubcategoryId.EventsAndExhibitions]: CategoryId.Attractions,
    [SubcategoryId.SkipTheQueue]: CategoryId.Attractions,
    [SubcategoryId.MuseumsAndGalleries]: CategoryId.Attractions,
    [SubcategoryId.ObservationDecks]: CategoryId.Attractions,
    [SubcategoryId.ShowsAndPerformances]: CategoryId.Attractions,
    [SubcategoryId.OtherAttractions]: CategoryId.Attractions,
    [SubcategoryId.AdultsOnlyAttractions]: CategoryId.Attractions,
    [SubcategoryId.AdventureAttractions]: CategoryId.Attractions,
    [SubcategoryId.ArtAndCulturalAttractions]: CategoryId.Attractions,
    [SubcategoryId.FamilyFriendlyAttractions]: CategoryId.Attractions,
    [SubcategoryId.HistoricalAttractions]: CategoryId.Attractions,
    [SubcategoryId.IndoorAttractions]: CategoryId.Attractions,
    [SubcategoryId.NatureAttractions]: CategoryId.Attractions,
    [SubcategoryId.NightTimeAttractions]: CategoryId.Attractions,
    [SubcategoryId.OutdoorAttractions]: CategoryId.Attractions,
    [SubcategoryId.RomanticAttractions]: CategoryId.Attractions,
    [SubcategoryId.AirportTransfer]: CategoryId.Transportation,
    [SubcategoryId.Buses]: CategoryId.Transportation,
    [SubcategoryId.HopOnHopOffTransportation]: CategoryId.Transportation,
    [SubcategoryId.CableCars]: CategoryId.Transportation,
    [SubcategoryId.VehicleRentals]: CategoryId.Transportation,
    [SubcategoryId.BicycleAndEScooterRentals]: CategoryId.Transportation,
    [SubcategoryId.WaterTransportation]: CategoryId.Transportation,
    [SubcategoryId.PrivateDrivers]: CategoryId.Transportation,
    [SubcategoryId.Trains]: CategoryId.Transportation,
    [SubcategoryId.OtherTransportation]: CategoryId.Transportation,
    [SubcategoryId.AirportFastTrack]: CategoryId.TravelEssentials,
    [SubcategoryId.AirportLounges]: CategoryId.TravelEssentials,
    [SubcategoryId.LuggageServices]: CategoryId.TravelEssentials,
    [SubcategoryId.OtherTravelEssentials]: CategoryId.TravelEssentials,
    [SubcategoryId.BicycleTours]: CategoryId.Tours,
    [SubcategoryId.BoatAndYachtTours]: CategoryId.Tours,
    [SubcategoryId.BusTours]: CategoryId.Tours,
    [SubcategoryId.HopOnHopOffTours]: CategoryId.Tours,
    [SubcategoryId.MotorbikeTours]: CategoryId.Tours,
    [SubcategoryId.PrivateCarTours]: CategoryId.Tours,
    [SubcategoryId.SelfGuidedTours]: CategoryId.Tours,
    [SubcategoryId.ShoppingTours]: CategoryId.Tours,
    [SubcategoryId.WalkingTours]: CategoryId.Tours,
    [SubcategoryId.FullDayTours]: CategoryId.Tours,
    [SubcategoryId.HalfDayTours]: CategoryId.Tours,
    [SubcategoryId.MultiDayTours]: CategoryId.Tours,
    [SubcategoryId.PrivateTours]: CategoryId.Tours,
    [SubcategoryId.SmallGroupTours]: CategoryId.Tours,
    [SubcategoryId.OtherTours]: CategoryId.Tours,
    [SubcategoryId.CulinaryTours]: CategoryId.Tours,
    [SubcategoryId.AdultsOnlyTours]: CategoryId.Tours,
    [SubcategoryId.AdventureTours]: CategoryId.Tours,
    [SubcategoryId.ArtAndCulturalTours]: CategoryId.Tours,
    [SubcategoryId.FamilyFriendlyTours]: CategoryId.Tours,
    [SubcategoryId.HistoricalTours]: CategoryId.Tours,
    [SubcategoryId.IndoorTours]: CategoryId.Tours,
    [SubcategoryId.LocalTours]: CategoryId.Tours,
    [SubcategoryId.LuxuryTours]: CategoryId.Tours,
    [SubcategoryId.NatureTours]: CategoryId.Tours,
    [SubcategoryId.NightTours]: CategoryId.Tours,
    [SubcategoryId.OutdoorTours]: CategoryId.Tours,
    [SubcategoryId.RomanticTours]: CategoryId.Tours,
    [SubcategoryId.SeasonalTours]: CategoryId.Tours,
    [SubcategoryId.SimCards]: CategoryId.SimCardsAndWifi,
    [SubcategoryId.Wifi]: CategoryId.SimCardsAndWifi,
    [SubcategoryId.OtherSimAndWifi]: CategoryId.SimCardsAndWifi,
    [SubcategoryId.BeautyAndSkincare]: CategoryId.Experiences,
    [SubcategoryId.ClothingAndCostumeRental]: CategoryId.Experiences,
    [SubcategoryId.PhotographyExperience]: CategoryId.Experiences,
    [SubcategoryId.SpasAndHotSprings]: CategoryId.Experiences,
    [SubcategoryId.WorkshopsAndClasses]: CategoryId.Experiences,
    [SubcategoryId.OtherExperiences]: CategoryId.Experiences,
    [SubcategoryId.AdultsOnlyExperiences]: CategoryId.Experiences,
    [SubcategoryId.AdventureExperiences]: CategoryId.Experiences,
    [SubcategoryId.ArtAndCulturalExperiences]: CategoryId.Experiences,
    [SubcategoryId.FamilyFriendlyExperiences]: CategoryId.Experiences,
    [SubcategoryId.HistoricalExperiences]: CategoryId.Experiences,
    [SubcategoryId.IndoorExperiences]: CategoryId.Experiences,
    [SubcategoryId.LocalExperiences]: CategoryId.Experiences,
    [SubcategoryId.LuxuryExperiences]: CategoryId.Experiences,
    [SubcategoryId.NatureExperiences]: CategoryId.Experiences,
    [SubcategoryId.NightlifeExperiences]: CategoryId.Experiences,
    [SubcategoryId.OutdoorExperiences]: CategoryId.Experiences,
    [SubcategoryId.RomanticExperiences]: CategoryId.Experiences,
    [SubcategoryId.SeasonalExperiences]: CategoryId.Experiences,
};

export const SubcategoryListByCategoryId: Record<CategoryId, SubcategoryId[]> = Object.entries(SubcategoryParentId).reduce<Record<CategoryId, SubcategoryId[]>>(
    (acc, [subcategoryId, categoryId]) => {
        if (!acc[categoryId]) {
            acc[categoryId] = [];
        }
        acc[categoryId].push(subcategoryId as SubcategoryId);
        return acc;
    },
    // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
    {} as Record<CategoryId, SubcategoryId[]>,
);

export const DefaultSubcategory: SubcategoryId[] = [
    SubcategoryId.OtherFoodAndDrinks,
    SubcategoryId.OtherAttractions,
    SubcategoryId.OtherTransportation,
    SubcategoryId.OtherTravelEssentials,
    SubcategoryId.OtherTours,
    SubcategoryId.OtherSimAndWifi,
    SubcategoryId.OtherExperiences,
];
